// ABOUTME: Modal for editing family basic information (name, description, timezone)
// ABOUTME: Used by admin to update family details

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { EditFamilyFormState } from '../types';

interface EditFamilyInfoModalProps {
  open: boolean;
  editForm: EditFamilyFormState;
  onClose: () => void;
  onChange: (form: EditFamilyFormState) => void;
  onSubmit: () => void;
}

const EditFamilyInfoModal: React.FC<EditFamilyInfoModalProps> = ({
  open,
  editForm,
  onClose,
  onChange,
  onSubmit
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Family Information</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Family Name"
            value={editForm.name}
            onChange={(e) => onChange({ ...editForm, name: e.target.value })}
            fullWidth
            required
          />
          <TextField
            label="Description"
            value={editForm.description}
            onChange={(e) => onChange({ ...editForm, description: e.target.value })}
            fullWidth
            multiline
            rows={3}
          />
          <TextField
            label="Timezone"
            value={editForm.timezone}
            onChange={(e) => onChange({ ...editForm, timezone: e.target.value })}
            fullWidth
            placeholder="e.g., America/New_York"
          />
          <FormControl fullWidth>
            <InputLabel id="admin-theme-selector-label">Theme</InputLabel>
            <Select
              labelId="admin-theme-selector-label"
              value={editForm.themeName}
              onChange={(e) => onChange({ ...editForm, themeName: e.target.value })}
              label="Theme"
            >
              <MenuItem value="default">Default</MenuItem>
              <MenuItem value="alt">Alt</MenuItem>
              <MenuItem value="nalu-v1">Nalu</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditFamilyInfoModal;
